import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { TabBar } from '../../../components/TabBar';
import { TabItem } from '../../../components/TabItem';
import { PrivacyPolicies } from './PrivacyPolicies';
import { TermsConditions } from './Terms&Conditions';

export default function Legal() {
  const [activeTab, setActiveTab] = useState('terms-conditions');
  const [searchParams, setSearchParams] = useSearchParams();

  const onTabChange = (newValue: string) => {
    setSearchParams({ type: newValue });
  };

  useEffect(() => {
    let activeType = searchParams.get('type');
    if (activeType) {
      setActiveTab(activeType);
    } else {
      setActiveTab('terms-conditions');
    }
  }, [searchParams]);

  return (
    // <MainBody>
    <div className="w-full flex flex-col gap-4 p-2 grow">
      <h1 className="text-xl font-semibold my-3">Policies</h1>

      <TabBar value={activeTab} onChange={onTabChange} textColor="text-black" indicatorColor="text-primary">
        <TabItem value={'terms-conditions'} label="Terms & conditions" />
        <TabItem value={'privacy-policy'} label="Privacy policy" />
      </TabBar>

      {activeTab === 'terms-conditions' && <TermsConditions />}

      {activeTab === 'privacy-policy' && <PrivacyPolicies />}
    </div>
    // </MainBody>
  );
}
